import Vue from 'vue'
import store from '@/store'

const Alert = {
    setAlert(show = true, type = 'success', message = ''){
        const paylod = { show, type, message }
        store.commit('utils/setAlert', paylod)
    }
}

Vue.prototype.$alert = Alert

export default Alert
